import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    mutation($network: String!, $accessToken: String!, $rememberMe: Boolean!, $jsonProfile: String!) {\n        socialLogin(network: $network, accessToken: $accessToken, rememberMe: $rememberMe, jsonProfile: $jsonProfile) {\n            ok\n            token\n            refreshToken\n            selector\n            validator\n            email\n            errors {\n                path\n                message\n            }\n        }\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import gql from 'graphql-tag';
import { Header, Image, Divider, Button, Form } from 'semantic-ui-react';
import { AuthClient, log
/* , AccountClient */
} from '@emyw/core-lib';
import { SocialLoginForm } from '@emyw/auth-lib';
import '../custom-theme.css';
var REACT_APP_ACCOUNT_API_IMAGE_PATH = process.env.REACT_APP_ACCOUNT_API_IMAGE_PATH;
var _process$env = process.env,
    REACT_APP_TOKEN_NAME = _process$env.REACT_APP_TOKEN_NAME,
    REACT_APP_REFRESH_TOKEN_NAME = _process$env.REACT_APP_REFRESH_TOKEN_NAME;
var socialLoginMutation = gql(_templateObject());
/* const getSignupStatusMutation = gql`
    mutation ($email: String!) {
        getSignupStatus(email: $email) {
            ok
            status
            planCode
            paymentMethod
            errors {
                path
                message
            }
        }
    }
`; */

var handleLogin = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(callback, socialUser) {
    var needsEmail, jsonProfile, response, _response$data$social, ok, errors, token, refreshToken;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // let signUpStatus = { status: 'unknown', planCode: '', paymentMethod: '' };
            needsEmail = false; // Use needsEmail instead so we can handle get signup status on client side
            // log.trace(socialUser.profile.email);

            if (!socialUser.profile.email) {
              _context.next = 10;
              break;
            }

            jsonProfile = JSON.stringify(socialUser.profile);
            _context.next = 5;
            return AuthClient.mutate({
              mutation: socialLoginMutation,
              variables: {
                network: socialUser.provider,
                accessToken: socialUser.token.accessToken,
                rememberMe: false,
                jsonProfile: jsonProfile
              }
            });

          case 5:
            response = _context.sent;
            _response$data$social = response.data.socialLogin, ok = _response$data$social.ok, errors = _response$data$social.errors, token = _response$data$social.token, refreshToken = _response$data$social.refreshToken; // log.trace(loginData);

            if (ok) {
              localStorage.setItem(REACT_APP_TOKEN_NAME, token);
              localStorage.setItem(REACT_APP_REFRESH_TOKEN_NAME, refreshToken);
            } else {
              log.trace('socialLogin error:', errors);
            }

            _context.next = 11;
            break;

          case 10:
            // signUpStatus = { status: 'needs_email', planCode: '', paymentMethod: '' };
            needsEmail = true;

          case 11:
            callback(socialUser,
            /* signUpStatus */
            needsEmail);

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function handleLogin(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var Step2Intro = function Step2Intro(_ref2) {
  var onContinueClick = _ref2.onContinueClick,
      onSocialLogin = _ref2.onSocialLogin,
      onSocialLoginFailure = _ref2.onSocialLoginFailure;
  return /*#__PURE__*/React.createElement("div", {
    className: "wizardStepBase createAccountIntro"
  }, /*#__PURE__*/React.createElement(Header, {
    color: "grey",
    as: "h2",
    textAlign: "center"
  }, /*#__PURE__*/React.createElement(Image, {
    size: "large",
    src: "".concat(REACT_APP_ACCOUNT_API_IMAGE_PATH, "/circle-check.png")
  }), /*#__PURE__*/React.createElement(Divider, {
    hidden: true
  }), /*#__PURE__*/React.createElement("div", {
    className: "stepTitle"
  }, "Create your account.", /*#__PURE__*/React.createElement(Header.Subheader, null, /*#__PURE__*/React.createElement("br", null), "Use your email and create a password", /*#__PURE__*/React.createElement("br", null), "to use Enjoy with your favorite", /*#__PURE__*/React.createElement("br", null), "supported video streaming service."))), /*#__PURE__*/React.createElement(Divider, {
    hidden: true
  }), /*#__PURE__*/React.createElement("div", {
    className: "subscribeStepContent"
  }, /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    onClick: onContinueClick,
    size: "large",
    primary: true,
    className: "subscribeNavigation square"
  }, "CONTINUE"), /*#__PURE__*/React.createElement(Divider, {
    hidden: true
  }), /*#__PURE__*/React.createElement(Divider, {
    horizontal: true
  }, "OR SIGN IN WITH"), /*#__PURE__*/React.createElement(Divider, {
    hidden: true
  }), /*#__PURE__*/React.createElement("div", {
    className: "subscribeNavigation"
  }, /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(SocialLoginForm, {
    onSocialLoginSuccess: function onSocialLoginSuccess(network, user) {
      return handleLogin(onSocialLogin, user);
    },
    onLoginFailure: function onLoginFailure(error) {
      return onSocialLoginFailure(error);
    }
  })))));
};

export default Step2Intro;